/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  categoryList: [],       // 대유형 목록
  mainCategoryList: [],   // 중유형 목록
  subCategoryList: [],    // 소유형 목록
  activeCategory: {},     // 선택된 대유형
  activeMainCategory: {}, // 선택된 중유형
  activeSubCategory: {}, // 선택된  소유형
  activeCurriculum: null,
  activeGradeId: null,
  activeSubjectTypeId: null,
  activeSubjectDetailTypeId: null,
  conceptBookData: {},
  
  // ✅ 목차별 생성용 데이터
  publisherList: [],
  textbookPublisherList: [],
  textbookSubjectList: [],
  activeTextbook: {},
  textbookContentList: [],
  textbookContentMainList: [],
  textbookContentSubList: [],

}
